import { render, staticRenderFns } from "./Amrieh.vue?vue&type=template&id=d827b592&scoped=true"
import script from "./Amrieh.vue?vue&type=script&lang=js"
export * from "./Amrieh.vue?vue&type=script&lang=js"
import style0 from "./Amrieh.vue?vue&type=style&index=0&id=d827b592&prod&scoped=true&lang=css"
import style1 from "./Amrieh.vue?vue&type=style&index=1&id=d827b592&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d827b592",
  null
  
)

export default component.exports